export function isHighUrgencyLevel(name: string): boolean {
  return name.trim().toLowerCase() === 'high';
}

const CUSTODIAL_AUTHORITY_STATUS_CODES = new Set(['IN_SL_CUSTODY', 'IN_FOREIGN_CUSTODY']);

/** Custodial Authority is required when custody status is In SL Custody or In Foreign Custody. */
export function requiresCustodialAuthority(statusName: string, statusCode?: string): boolean {
  const code = (statusCode ?? '').trim().toUpperCase();
  if (code && CUSTODIAL_AUTHORITY_STATUS_CODES.has(code)) return true;

  const n = statusName.trim().toLowerCase();
  return n.includes('sl custody') || n.includes('foreign custody');
}
